import CollectionBreadcrumb from "components/Collection/CollectionBreadcrumb"

import MobileTitleBar from "components/MobileTitleBar"
import ProductCard from "components/Product/ProductCard"
import { observer } from "mobx-react"
import React, { Component } from "react"
import Responsive from "react-responsive"
import queryString from "qs"
import { browserHistory } from "react-router-dom"
import _ from "lodash"
import { Button, Card, Container, Dropdown, Menu, Visibility } from "semantic-ui-react"
import { Link } from "react-router-dom"
import shop from "shop/shop"
import productStore from "stores/productStore"
import ProductListItem from "components/Product/ProductListItem"
import cmsStore from "stores/cmsStore"
import WordPress from "WordPress"
import "style/CollectionPage.scss"

@observer
export default class ExplorerPage extends Component {

	state = {
		products: [],
		currentOffset: 0,
		sort: "sort",
		dir: "asc",
		view: "grid",
		onEnd: this.loadNext
	}

	componentDidMount() {
		this.loadNext()
	}

	componentWillReceiveProps(props) {
		console.log("reload")
		let tempOffset = decodeURIComponent(props.location.search)
		let offsetMatch = tempOffset.match(/\?offset=([^&]*)$/)
		let offsetValue = offsetMatch ? offsetMatch[1] : ""
		console.log("NEW PROPS location", props, offsetValue)
		this.reset(props, offsetValue)
	}

	setSort = (e, { value }) => {
		let item = sortOptions.find(item => item.value === value)
		if (item) {
			this.setState({ sort: item.value })
			this.setState({ dir: item.dir })
		}
		//this.setState({ sort: value })
		this.reset()
	}

	setDir = (e, { value }) => {
		this.setState({ dir: value })
		this.reset()
	}

	setView = (e, { value }) => {
		this.setState({ view: value })
		this.reset()
	}

	reset = (props, offsetValue) => {
		this.setState({ currentOffset: offsetValue ? offsetValue : 0, products: [] }, () => this.loadNext(props))
	}

	handleUpdate = (e, { calculations }) => {
		if (calculations.topVisible) this.loadNext()
	}

	loadNext = (props = this.props) => {
		if (this.state.loading) return
		this.setState({ loading: true })
		let { categoryId } = props.match.params
		let category = shop.categoriesById.get(categoryId)
		let tempOffset = decodeURIComponent(props.location.search)
		let offsetMatch = tempOffset.match(/\?offset=([^&]*)$/)
		let offsetValue = offsetMatch ? offsetMatch[1] : ""

		console.log("location loadNext", props, categoryId, this.state.currentOffset, offsetValue)
		const query = {
			query: "",
			page: this.state.currentOffset + 1,
			count: 8,
			sort: this.state.sort,
			dir: this.state.dir
		}

		console.log('explorer page load');
		productStore.fromCategory(categoryId, query)
			.then(res => {
				let { products } = res
				if (products.length === 0) {
					if (products.length === 0 && shop.config.collections.showProductsFromSubCategories) {
						// get products from all child categories
						const ids = _.flatten(category && category.children.map(mapChildren))
						if (ids.length > 0) {

							return productStore.fromCategory(ids, query)
						}
					}
				}
				return res
			})
			.then(res => {
				// Merge and filter out duplicate products by map_id
				const mergedProducts = _.uniqBy(
					this.state.products.concat(...res.products),
					'map_id'
				)
				this.setState({
					currentOffset: this.state.currentOffset + 1,
					loading: false,
					size: res.size,
					products: mergedProducts
				})
				console.log("ExplorerPage loaded products", mergedProducts.length, res)
			})
			.catch(err => {
				console.error("ERROR", err)
				this.setState({
					loading: false
				})
			})
	}

	render() {
		let { categoryId } = this.props.match.params
		const { loading } = productStore
		const { products, size, listview, currentOffset } = this.state
		const query = queryString.parse(this.props.location.search, { ignoreQueryPrefix: true })
		const view = this.state.view || shop.config.filter_defaults.view || "list"
		const dir = this.state.dir || shop.config.filter_defaults.dir || "asc"
		let page = cmsStore.contentByCategory.get(categoryId)
		console.log("CURRENT OFFSET location", currentOffset, decodeURIComponent(this.props.location.search))

		if (products.length === 0 && !loading)
			return <div className={"vh-75 tc flex justify-center items-center"}>
				<div>
					<h3>{translate("BrandUnavailable")}</h3>
				</div>
			</div>

		return (
			<div className="ExplorerPage">


				<Container className="pt4 pb5 ">
					{page && <WordPress page={page} />}
					<Responsive minWidth={630}>
						<div className="pb4 z-99 relative">
							<div className="fr flex justify-between">
								<div className="pr2 content-center">
									{this.state.size} Produkte
								</div>
								<div className="pr2" style={{zIndex:"1000"}}>
									<Dropdown closeOnChange selection value={this.state.sort} options={sortOptions} item onChange={this.setSort} />
								</div>
								<div>
									<Button.Group basic size="small">
										<Button active={dir === "desc"} value="desc" onClick={this.setDir} icon={"chevron down"} />
										<Button active={dir === "asc"} value="asc" onClick={this.setDir} icon={"chevron up"} />
									</Button.Group>
								</div>
								<div className={"pl2 pr0"}>
									<Button.Group basic size="small">
										<Button active={view === "grid"} value="grid" onClick={this.setView} icon={"th"} />
										<Button active={view === "list"} value="list" onClick={this.setView} icon={"th list"} />
									</Button.Group>
								</div>
							</div>
							<div className="pt2">
								<CollectionBreadcrumb id={categoryId} />
							</div>
						</div>
					</Responsive>
					<Responsive maxWidth={630}>
						<div className="pb4 z-99 relative">
							<div className="pb1 flex justify-end">
								<div className="pr2 content-center">
									{this.state.size} Produkte
								</div>
								<div className="pr2" style={{zIndex:"1000"}}>
									<Dropdown closeOnChange selection value={this.state.sort} options={sortOptions} item onChange={this.setSort} />
								</div>
							</div>
							<div className="pr2 flex justify-end">
								<div className="w-100 pt2">
									<CollectionBreadcrumb id={categoryId} />
								</div>
								<div>
									<Button.Group basic size="small">
										<Button active={dir === "desc"} value="desc" onClick={this.setDir} icon={"chevron down"} />
										<Button active={dir === "asc"} value="asc" onClick={this.setDir} icon={"chevron up"} />
									</Button.Group>
								</div>
								<div className={"pl2 pr0"}>
									<Button.Group basic size="small">
										<Button active={view === "grid"} value="grid" onClick={this.setView} icon={"th"} />
										<Button active={view === "list"} value="list" onClick={this.setView} icon={"th list"} />
									</Button.Group>
								</div>
							</div>
						</div>
					</Responsive>
					{view === "grid" && <Card.Group itemsPerRow="4" doubling>
						{products.map((product, key) =>
							<ProductCard key={product.map_id} product={product} currentOffset={currentOffset}/>
						)}
						<Visibility fireOnMount onUpdate={this.handleUpdate} />
					</Card.Group>}
					{view === "list" && <div key={this.props.location.pathname + this.props.location.search}
						className="catalog-products catalog-products--list">
						{products.map((product, index) => <ProductListItem
							index={index}
							key={product.map_id}
							product={product}
							 />)}
						<Visibility fireOnMount onUpdate={this.handleUpdate} />
					</div>}
					{/*<ProductMapper products={products} onEnd={this.loadNext} />*/}
				</Container>
			</div>
		)
	}
}

let sortOptions = [
	{
		key: "Standard",
		text: translate("Standard"),
		value: "sort",
		dir: "asc"
	},
	{
		key: "A-Z",
		text: translate("A-Z"),
		value: "extra:sortdes",
		dir: "asc"
	},
	{
		key: "Artikel-Nr.",
		text: translate("Artikel Nr."),
		value: "article_nr",
		dir: "desc"
	},
	{
		key: "Neuheit",
		text: translate("NeuheitSort"),
		value: "extra:neuheit",
		dir: "desc"
	},
	{
		key: "Topseller",
		text: translate("Topseller"),
		value: "extra:articletype",
		dir: "desc"
	}
]

{/*
const SelectSort = ({ value, onChange }) => (
	<Menu compact>
		<Dropdown size="small" closeOnChange value={value} options={sortOptions} item onChange={onChange} />
	</Menu>
)
*/}

{/*
class ProductMapper extends Component {

	handleUpdate = (e, { calculations }) => {
		if (calculations.topVisible) this.props.onEnd()
	}

	render() {
		const { products } = this.props
		let l = products.length
		//console.log( "ProductMapper render", l, products )
		return (
			<Card.Group itemsPerRow="4" doubling>
				{products.map((product, key) =>
					<ProductCard key={product.map_id} product={product} />
				)}
				<Visibility fireOnMount onUpdate={this.handleUpdate} />
			</Card.Group>
		)
	}


}
*/}

const mapChildren = cat => {
	if (cat.children.length > 0) return _.map(cat.children, mapChildren)
	return cat.map_id
}


// WEBPACK FOOTER //
// ./src/theme/mags/pages/ExplorerPage.js